import axios from "axios";
import { getPHP_Url } from "../../../MIS/Global";

export const handleWA_text_sms = async ({ 
  setSmsLoading,mobile,
  genCalcOtp
}) => {  
  const url = `${getPHP_Url()}wa/send-text`;  
  
  const params = {    
    mob: mobile,
    text: "*password reset*",
    otp: `*${genCalcOtp}*`    
  };  
  
  setSmsLoading(true);
  try {
    const response = await axios.get(url, { params });
    // alert(1)
    // alert("API Response: " + JSON.stringify(response?.data));
  } catch (err) {
    // alert("Errors: " + err.message + "\nDetails: " + JSON.stringify(err));
    // console.log(err)
  } finally {
    // setSmsLoading(false);
  }
};

export const handleWA_verify_sms = async ({ 
  setIsVerify,mob,otp,setStep,showToast
}) => {  
  const url = `${getPHP_Url()}wa/verify`;    
  const params = {   
    mob:mob,
    otp: otp
  };  
  
  setIsVerify(true);
  try {
    const response = await axios.get(url, { params });
    // alert(1)
    if(response?.data?.match===true){
      setStep((prev) => prev + 1);
    }else{
      showToast('Invalid otp! Please try again', 'danger');      
    }
  } catch (err) {
    // alert("Errors: " + err.message + "\nDetails: " + JSON.stringify(err));
    // console.log(err)
  } finally {
    setIsVerify(false);
  }
};

